import { render } from "./icon-feather.vue?vue&type=template&id=277a8b1d"
import script from "./icon-feather.vue?vue&type=script&lang=js"
export * from "./icon-feather.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__